export const formatNum = (value: number): string => {
  const newNum = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return newNum;
};
